import * as React from "react";
import Tooltip from '@mui/material/Tooltip';
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import Drawer from "@mui/material/Drawer";
import { Avatar, ButtonGroup } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from '../Includes/Header';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useEffect, useRef } from "react";
import { Card, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper, Stack, Breadcrumbs, Link } from "@mui/material";
import { useLocation } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PersonIcon from "@mui/icons-material/Person";
import PaymentIcon from "@mui/icons-material/Payment";
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import {
  AutoInvoiceNumber,
  MemberDuePayment,
} from "../Apihelper/ApiHelperPayment";
import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';
import PayButton from "../../components/PayButton/PayButton";

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

function Payment(props) {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // Default to 'success'
  
  const { paymentData } = location.state;
  const [FormData, setFormData] = useState({
    
    invoice_number: '',
    modeofpayment:'',
    payingAmount:'',
    discount: '',
    dateofpayment: dayjs(),
    member_id:'',
    payment_id:'',
  });

  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

 
  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

 

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }

  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      border: 0,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
 
 
 
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };
  const fetchData = async () => {
    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; 
        const res = await AutoInvoiceNumber(userToken, userId);

        if (res.code == "200") {
         
            setFormData({ ...FormData, invoice_number: res.data });
          
        } else {
           // handleSnackbarOpen(res.message, 'error');
           console.error(error); 
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
};
useEffect(() => {
 
  fetchData();
}, []);
const handlePayingAmountChange = (event, dueAmount) => {
  let inputValue = event.target.value;

  // Ensure that only numeric values are entered
  inputValue = inputValue.replace(/\D/g, ''); // Remove non-numeric characters

  // Ensure that paying amount + discount together don't exceed the due amount
  const discount = Number(FormData.discount) || 0;
  if (Number(inputValue || 0) + discount <= dueAmount) {
    // Update the payingAmount field in FormData
    setFormData({ ...FormData, payingAmount: inputValue });
  }
};

const handleDiscountChange = (event, dueAmount) => {
  let inputValue = event.target.value;

  // Ensure that only numeric values are entered
  inputValue = inputValue.replace(/\D/g, '');

  if (Number(inputValue || 0) <= dueAmount) {
    // Auto-fill the paying amount as due minus discount; it can still be
    // lowered afterward to leave part of it as a remaining due.
    const autoPayingAmount = Math.max(0, dueAmount - Number(inputValue || 0));
    setFormData({ ...FormData, discount: inputValue, payingAmount: String(autoPayingAmount) });
  }
};

const handleSubmit = async (member_id, payment_id) => {
  const userData = localStorage.getItem("userdata");
  const userDataObj = JSON.parse(userData);
  const userToken = userDataObj.token;
  const userId = userDataObj.id; 

  const requestData = {
    ...FormData,
    member_id: member_id,
    payment_id: payment_id,
    dateofpayment: FormData.dateofpayment
      ? dayjs(FormData.dateofpayment).format('YYYY-MM-DD')
      : dayjs().format('YYYY-MM-DD'),
  };

  console.log(requestData);

  // Check if payingAmount is 0, if so, don't call the API
  if (FormData.payingAmount == 0) {
    handleSnackbarOpen('Paying amount cannot be zero.', 'error');
    return; // Exit the function to prevent the API call
  }

  try {
    const res = await MemberDuePayment(userToken, userId, requestData);
    if (res.code == "200") {
      handleSnackbarOpen(res.message, 'success');
      setFormData({
        invoice_number: '',
        modeofpayment: '',
        payingAmount: '',
        discount: '',
        dateofpayment: dayjs(),
      });
     
      navigate('/memberdetails', {
        state: {
          id: member_id,
          random_no: Math.random(),
        },
      });
     
    } else {
      handleSnackbarOpen(res.message, 'error');
    }
  } catch (error) {
    console.error(error); // Handle error
  }
};

React.useEffect(() => {
  const storedData = localStorage.getItem("userdata");
  if (!storedData) {
    // User is not logged in, no need to redirect
    navigate('/');
  }
  
}, []);
  return (
    <Box sx={{ display: 'flex', backgroundColor: "#EFEDF1", minHeight: '100vh' }}>
      <Header />
      <CssBaseline />
      <Box component="main" sx={{ flexGrow: 1, minWidth: 0, overflowY: 'auto', padding: '20px' }}>
        <div style={{ display: 'flex', flexGrow: 1, marginTop: '50px' }}>
          <div style={{ flex: 1, minWidth: 0, marginTop: '15px' }}>
          {/* Header Section */}
          <Card sx={{ p: { xs: 2, sm: 3 }, mb: 3, borderRadius: 2, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
            <Stack 
              direction={{ xs: 'column', sm: 'row' }} 
              alignItems={{ xs: 'stretch', sm: 'center' }} 
              justifyContent="space-between"
              spacing={2}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <IconButton
                  onClick={() => navigate(-1)}
                  sx={{
                    bgcolor: appColors.leaf,
                    color: 'white',
                    '&:hover': { bgcolor: appColors.pine },
                  }}
                >
                  <ArrowBackIcon sx={{ fontSize: 20 }} />
                </IconButton>
                <Box>
                  <Typography variant="h5" sx={{ color: appColors.leaf, fontWeight: 600 }}>
                    Due Payment
                  </Typography>
                  <Breadcrumbs sx={{ mt: 0.5 }}>
                    <Link underline="hover" color="inherit" href="#" onClick={() => navigate('/dashboard')}>
                      Home
                    </Link>
                    <Typography color="text.primary">Due Payment</Typography>
                  </Breadcrumbs>
                </Box>
              </Stack>
            </Stack>
          </Card>
            {Object.keys(paymentData).map((key, index) => {
              const due = paymentData[key].due;
              const overLimit = parseFloat(FormData.payingAmount || 0) + parseFloat(FormData.discount || 0) > due;
              return (
              <Card key={key} sx={{ mt: 2.5, mb: 2, borderRadius: 3, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', overflow: 'hidden' }}>
                {/* Member summary strip */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                    background: `linear-gradient(135deg, ${appColors.evergreen} 0%, ${appColors.leaf} 100%)`,
                    color: '#fff',
                    flexWrap: 'wrap',
                  }}
                >
                  <Avatar sx={{ height: 64, width: 64, bgcolor: 'rgba(255,255,255,0.2)' }}>
                    <PersonIcon sx={{ fontSize: 34 }} />
                  </Avatar>
                  <Box sx={{ flex: 1, minWidth: 160 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                      {paymentData[key].name}
                    </Typography>
                    <Typography sx={{ opacity: 0.85, fontSize: '0.875rem' }}>
                      {paymentData[key].phone}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      textAlign: 'right',
                      bgcolor: 'rgba(255,255,255,0.15)',
                      borderRadius: 2,
                      px: 2.5,
                      py: 1,
                    }}
                  >
                    <Typography sx={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.08em', opacity: 0.85 }}>
                      Due Amount
                    </Typography>
                    <Typography sx={{ fontWeight: 700, fontSize: '1.35rem' }}>
                      ₹{due}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ px: { xs: 2, sm: 3 }, py: 3 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: 'text.secondary', mb: 2 }}>
                    Payment Details
                  </Typography>
                  <Grid container spacing={2.5}>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <TextField
                        label="Discount"
                        fullWidth
                        placeholder="Enter Discount..."
                        value={FormData.discount}
                        onChange={(event) => handleDiscountChange(event, due)}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <TextField
                        label="Paying Amount"
                        fullWidth
                        placeholder="Enter Paying Amount..."
                        value={FormData.payingAmount}
                        onChange={(event) => handlePayingAmountChange(event, due)}
                        error={overLimit}
                        helperText={overLimit ? "Paying amount + discount cannot be greater than due amount" : null}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <FormControl fullWidth>
                        <InputLabel id={`mode-of-payment-label-${key}`}>Mode of Payment</InputLabel>
                        <Select
                          labelId={`mode-of-payment-label-${key}`}
                          value={FormData.modeofpayment}
                          onChange={(e) => setFormData({ ...FormData, modeofpayment: e.target.value })}
                          label="Mode of Payment"
                        >
                          <MenuItem value="paytm">Paytm</MenuItem>
                          <MenuItem value="googlepay">Google Pay</MenuItem>
                          <MenuItem value="phonepe">PhonePe</MenuItem>
                          <MenuItem value="cash">Cash</MenuItem>
                          <MenuItem value="card">Card</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Payment Date"
                          value={FormData.dateofpayment}
                          onChange={(date) => setFormData({ ...FormData, dateofpayment: date })}
                          format="DD/MM/YYYY"
                          clearable
                          slotProps={{ textField: { fullWidth: true } }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <TextField
                        label="Invoice No"
                        inputProps={{ readOnly: true }}
                        fullWidth
                        value={FormData.invoice_number}
                        placeholder="invoice number"
                      />
                    </Grid>
                  </Grid>

                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 3.5, justifyContent: 'flex-end', gap: 1.5 }}>
                    <Button
                      sx={{
                        textTransform: 'none',
                        whiteSpace: 'nowrap',
                        fontWeight: 600,
                        color: appColors.leaf,
                        borderColor: appColors.leaf,
                        '&:hover': {
                          borderColor: appColors.pine,
                          backgroundColor: 'rgba(31, 122, 84, 0.04)',
                        }
                      }}
                      variant="outlined"
                      type="reset"
                    >
                      Cancel
                    </Button>
                    <PayButton overlay
                      onClick={() => handleSubmit(paymentData[key].member_id, paymentData[key].payment_id)}
                      startIcon={<PaymentIcon />}
                      sx={{
                        textTransform: 'none',
                        whiteSpace: 'nowrap',
                        fontWeight: 600,
                        backgroundColor: appColors.leaf,
                        '&:hover': {
                          backgroundColor: appColors.pine,
                        }
                      }}
                      variant="contained"
                    >
                      Payment
                    </PayButton>
                  </Box>
                </Box>
              </Card>
              );
            })}
          </div>

        </div>

      </Box>




      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>



  );
}

export default Payment;